import { BLAdmin } from '@/types/profile.types';
import jwtDecode from '@/utils/jwt';

const getUserFromToken = (token: string): BLAdmin => jwtDecode(token);

export default getUserFromToken;
